module.exports = __webpack_public_path__ + "static/media/bb.8d8c90d7.svg";